import request from '@/util/request'

/**
 * 获取用户信息
 */
export function userInfo (params) {
  return request({
    url: `/api/sale/website/user`,
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js